import { render } from "./PopupManageCreatePage.vue?vue&type=template&id=4888e199&lang=true"
import script from "./PopupManageCreatePage.vue?vue&type=script&lang=js"
export * from "./PopupManageCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__